import {SmileHealthEnvironmentInterface} from '../app/interfaces/environment.interface';

export const environment: SmileHealthEnvironmentInterface = {
  production: true,
  appInsights: {
    instrumentationKey: '[[INSTRUMENTATION_KEY]]'
  },
  recaptcha: {
    siteKey: '[[RECAPTCHA_KEY]]'
  },
  identityUrl: '[[IDENTITYURL]]',
  apiUrl: '[[APIURL]]',
  apiEndpoint: 'treatment/member-portal/',
  treatmentApi: '[[TREATMENTAPI]]',
  pdfApiEndpoint: 'pdfapicore/',
  pdfUrl: '[[PDF]]',
  salesEndpoint: 'sales/',
  paymentsEndpoint: 'payments/',
  blobStorageUrl: '[[BLOB_STORAGE_URL]]',
  siteGraphicUrl: '[[SITE_GRAPHIC_URL]]',
  idleTimeout: 600,
  AdobeAnalyticsUrl: '[[ADOBEANALYTICSURL]]',
  enableAnalytics: '[[ENABLEANALYTICS]]',
  portalId: '[[PORTAL_ID]]',
  statusCheckSecond: '[[STATUS_CHECK_SECONDS]]',
  memberPortalLink: '[[MEMBER_PORTAL_LINK]]',
  providerPortalLink: '[[PROVIDER_PORTAL_LINK]]',
  salesApiUrl: '[[SALESAPIURL]]',
  publicCaptchaKey: '[[PUBLIC_CAPTCHA_KEY]]',
  eProtectUrl: '[[EPROTECTURL]]',
  payPageId: '[[PAYPAGEID]]',
  reportGroup: 'Default',
  smileHealthPortalUrl: 'https://smilehealth.com',
  useContentCachedData: true,
  smartSearchEnvironment: '[[SMART_SEARCH_ENVIRONMENT]]',
  clarityKey:'[[CLARITY_KEY]]',
  widgetApi: '[[WIDGET_API]]',
  googleMapsApiKey: '[[GOOGLE_MAPS_API_KEY]]'
};
